module.exports = __webpack_public_path__ + "images/marketing/pipelinedeals-list-view-editing.png";